import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navigationItems } from '../data/mock';

const Header = () => {
  const location = useLocation();

  return (
    <header className="bg-[#FFDA00] shadow-md">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex items-center justify-between py-3">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src="https://customer-assets.emergentagent.com/job_af379c3c-fcd6-4194-be29-caf51021bd6a/artifacts/tv2sat07_Logo.png"
              alt="Agri Direct Australia"
              className="h-14"
            />
          </Link>

          {/* Navigation */}
          <nav className="hidden md:flex items-center gap-1">
            {navigationItems.map((item) => (
              <Link
                key={item.id}
                to={item.href}
                className={`px-4 py-2 text-sm font-medium transition-all duration-200 rounded ${
                  location.pathname === item.href
                    ? 'bg-[#E6C400] text-white'
                    : 'text-white/90 hover:bg-[#E6C400] hover:text-white'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-white p-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
